import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=764ca11e&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=ts"
export * from "./Step2.vue?vue&type=script&lang=ts"
import style0 from "./Step2.vue?vue&type=style&index=0&id=764ca11e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764ca11e",
  null
  
)

export default component.exports